module.exports = __webpack_public_path__ + "static/media/2.1d06a4d0.jpg";